var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(!_vm.pageLoading)?_c('div',{staticClass:"murk"},[_c('BalanceInfo',{attrs:{"title":_vm.isIngamePurchase
					? _vm.$t('checkout.title')
					: _vm.region === 'global'
					? _vm.$t('checkout.buy-nx')
					: _vm.$t('add-balance'),"show-switch-account":!_vm.isIngamePurchase,"is-in-game":_vm.isIngamePurchase}}),_c('div',{staticClass:"purchase-wrapper"},[_c('div',{staticClass:"summary-container"},[(_vm.isIngamePurchase)?_c('InGameSummary'):_c('Summary')],1),_c('div',{staticClass:"billing-payment-container"},[(_vm.region === 'global')?_c('BillingLocation'):_vm._e(),_c('PaymentMethod')],1)])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }